import type { RejectIncomingCallUsecase } from '@usecases/reject-incoming-call.usecase';

import type { BaseController } from '@infra/controllers/base.controller';
import type { Call } from '@entities/call';

export type RejectIncomingCallInput = {
  callId: string;
};

export type RejectIncomingCallOutput = Call | void;

export class RejectIncomingCallController
  implements BaseController<RejectIncomingCallInput, RejectIncomingCallOutput>
{
  constructor(private usecase: RejectIncomingCallUsecase) {}

  async handle({
    callId,
  }: RejectIncomingCallInput): Promise<RejectIncomingCallOutput> {
    return this.usecase.run({ callId });
  }
}
